module.exports = __webpack_public_path__ + "img/weixin.63c6bd68.jpg";